import type { Table } from './DatasetTableTypes'
import './QuestionData.css'

interface QuestionDataProps {
  dataType: 'Table' | 'DataFrame'
  tables: Table[] | undefined
  pythonOutputType?: string
}

function QuestionData({
  dataType,
  tables,
  pythonOutputType = undefined,
}: QuestionDataProps) {
  const title = tables && tables.length > 1 ? `${dataType}s` : dataType

  return (
    <>
      <div className="QuestionPane__question-data QuestionPane__question-data--tables">
        {title}: {tables?.map((t) => t.name).join(', ')}
      </div>
      {pythonOutputType && (
        <div className="QuestionPane__question-data QuestionPane__question-data--type">
          Expected Output Type: {pythonOutputType}
        </div>
      )}
    </>
  )
}

export default QuestionData
